import {Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import './index.styl';

/**
 * This interface represents the shape of the JSON responses that the /security/totp/
 * endpoint returns.
 */

export class ManualCodeModal extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      secret: {type: `string`, description: `secret for adding TOTP manually`},
    };
  }

  get config(): ConfigOptions<EmptyObj> {
    return {
      template,
      defaultState: {},
      helpers: {
        closeSecretCodeModal: (): void => {
          this.dispatchEvent(new CustomEvent(`close`));
        },
      },
    };
  }

  connectedCallback(): void {
    super.connectedCallback();
  }
}

export const ManualCodeModalEl = defineAndMakeJsxFactory(`mp-totp-manual-code-modal`, ManualCodeModal);
export const ManualCodeModalReact = panel2react(`mp-totp-manual-code-modal`, ManualCodeModal);
